'use client'

import Link from 'next/link'
import {ReactNode} from 'react'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {FooterEvent} from '../analytics/events'

type Props = {
  children: ReactNode
  href: string
  className?: string
  linkName: string
}

const FooterLink = ({children, href, className, linkName}: Props) => {
  return (
    <Link
      href={href}
      className={className}
      prefetch={false}
      onClick={() => triggerAnalytics(FooterEvent.LinkClicked, {'link-clicked': linkName}).sendAll()}
    >
      {children}
    </Link>
  )
}

export default FooterLink
